import { render, staticRenderFns } from "./ModelNotePersons.vue?vue&type=template&id=13709ed8&scoped=true"
import script from "./ModelNotePersons.vue?vue&type=script&lang=js"
export * from "./ModelNotePersons.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13709ed8",
  null
  
)

export default component.exports